import { render, staticRenderFns } from "./itc-index.vue?vue&type=template&id=7a8c8d12&scoped=true"
import script from "./itc-index.vue?vue&type=script&lang=js"
export * from "./itc-index.vue?vue&type=script&lang=js"
import style0 from "./itc-index.vue?vue&type=style&index=0&id=7a8c8d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8c8d12",
  null
  
)

export default component.exports